import React, { useEffect, useState } from "react";
import "./DesignerProfile.scss";
import { Button, Card, Table } from "react-bootstrap";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import { useNavigate, useParams } from "react-router-dom";
import DesignerCardInfoFull from "../../components/DesignerCardInfoFull";
import Stars from "../../components/Stars";
import TabsHeader from "../../components/TabsHeader";
import TabsBody from "../../components/TabsBody";
import { useLocalDB } from "../../contexts/LocalDBContext";
import LikeButton from "../../components/LikeButton";
import SubscribeButton from "../../components/SubscribeButton";

const DesignerProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { getStudioById, getArticlesByStudioId, getPortfoliosByStudioId } = useLocalDB();

  useBackButton("/", false, false);

  const [studio, setStudio] = useState(null);
  const [articles, setArticles] = useState([]);
  const [portfolios, setPortfolios] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { label: "Портфолио" },
    { label: "Статьи" },
    { label: "Отзывы" },
  ];

  useEffect(() => {
    const load = async () => {
      const studioData = await getStudioById(id);
      const a = await getArticlesByStudioId(id);
      const p = await getPortfoliosByStudioId(id);
      setStudio(studioData);
      setArticles(a);
      setPortfolios(p);
    };

    if (id) {
      load();
    }
  }, [id]);

  if (!studio) return null;

  return (
    <>
    <Header></Header>
    <SubHeader></SubHeader>
    
    <div className="row user-page">
      <div className="col col-0 cancel col-md-3">
        <div className="return-btn" onClick={() => {navigate("/")}}> 
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 20C0 16.2828 0 14.4241 0.307436 12.8786C1.56994 6.53151 6.53151 1.56994 12.8786 0.307436C14.4241 0 16.2828 0 20 0C23.7172 0 25.5759 0 27.1214 0.307436C33.4685 1.56994 38.4301 6.53151 39.6926 12.8786C40 14.4241 40 16.2828 40 20C40 23.7172 40 25.5759 39.6926 27.1214C38.4301 33.4685 33.4685 38.4301 27.1214 39.6926C25.5759 40 23.7172 40 20 40C16.2828 40 14.4241 40 12.8786 39.6926C6.53151 38.4301 1.56994 33.4685 0.307436 27.1214C0 25.5759 0 23.7172 0 20Z"
              fill="white" />
            <path fillRule="evenodd" clipRule="evenodd"
              d="M23.0893 14.4108C22.7638 14.0854 22.2362 14.0854 21.9108 14.4108L16.9108 19.4108C16.7545 19.5671 16.6667 19.7791 16.6667 20.0001C16.6667 20.2211 16.7545 20.4331 16.9108 20.5893L21.9108 25.5893C22.2362 25.9148 22.7638 25.9148 23.0893 25.5893C23.4147 25.2639 23.4147 24.7363 23.0893 24.4108L18.6785 20.0001L23.0893 15.5893C23.4147 15.2639 23.4147 14.7363 23.0893 14.4108Z"
              fill="#191A21" />
          </svg>
          Назад
        </div>
        
      </div>
      <div className="col col-12 col-md-9">
        <div className="card">
          <div className="profile-image" style={{ backgroundImage: `url('/images/${studio.background}')` }}></div>
          <div className="row">
            <div className="col col-12">
              <div className="align-self-center" style={{position: "relative"}}>
                <img className="mx-auto d-block circle avatar" src={`/images/${studio.avatar}`} alt="" />
                <span className="star-container">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd"
                      d="M6.61108 1.09924C6.8561 0.977662 7.14389 0.977662 7.38891 1.09924C7.60508 1.2065 7.71782 1.39497 7.77195 1.49199C7.8305 1.59692 7.89047 1.73151 7.95039 1.86601C7.95327 1.87248 7.95615 1.87894 7.95903 1.8854L9.00732 4.23715L11.589 4.50963C11.7355 4.52506 11.882 4.5405 11.9999 4.56376C12.1089 4.58526 12.323 4.63424 12.4918 4.80668C12.6831 5.00214 12.772 5.27584 12.7321 5.54645C12.6969 5.78518 12.5525 5.95064 12.477 6.03211C12.3953 6.12021 12.2858 6.21883 12.1764 6.31738L10.2479 8.05532L10.7866 10.5949C10.8171 10.7389 10.8477 10.883 10.8621 11.0023C10.8753 11.1126 10.8949 11.3314 10.783 11.5452C10.6562 11.7876 10.4234 11.9568 10.1537 12.0024C9.91581 12.0427 9.71381 11.9565 9.61299 11.9098C9.50396 11.8593 9.37635 11.7857 9.24882 11.7121L6.99999 10.4151L4.75116 11.7121C4.62364 11.7857 4.49603 11.8593 4.387 11.9098C4.28618 11.9565 4.08418 12.0427 3.84626 12.0024C3.57657 11.9568 3.34374 11.7876 3.21697 11.5452C3.10514 11.3314 3.12471 11.1126 3.13794 11.0023C3.15225 10.883 3.18285 10.7389 3.21342 10.5949L3.75207 8.05532L1.83936 6.3316C1.83411 6.32686 1.82885 6.32212 1.82359 6.31739C1.71419 6.21883 1.60472 6.12021 1.52302 6.03211C1.44748 5.95064 1.30307 5.78518 1.26786 5.54645C1.22795 5.27584 1.31688 5.00215 1.50822 4.80668C1.67703 4.63424 1.89112 4.58526 2.00012 4.56376C2.118 4.5405 2.26453 4.52506 2.41096 4.50963C2.418 4.50889 2.42504 4.50815 2.43208 4.5074L4.99267 4.23715L6.04096 1.8854C6.04384 1.87894 6.04672 1.87247 6.0496 1.866C6.10953 1.73151 6.16949 1.59692 6.22804 1.49199C6.28217 1.39497 6.39491 1.2065 6.61108 1.09924Z"
                      fill="#FE9402" />
                  </svg>
                  {studio.rating}
                </span>
              </div>
            </div>
            <div className="col col-12">
              <div className="d-flex flex-column" style={{textAlign: "center"}}>
                <h2>{studio.name}</h2>
                <div className="mt-1 subsribes">{studio.subscribers} подписчиков</div>
                <p className="mt-3">{studio.description}</p>
              </div>
            </div>
            <div className="col col-12 mt-3">
              <div className="row">
                <div className="col col-md-6 col-md-6 col-12 mt-2">
                  <button className="btn btn-black">Подписаться</button>
                </div>
                <div className="col col-md-6 col-md-6 col-12 mt-2">
                  <button className="btn btn-white">Написать</button>
                </div>
                <div className="col col-12 mt-2">
                  <button className="btn btn-white" onClick={() => {navigate("/order-new")}}>Предложить заказ</button>
                </div>
              </div>
            </div>
            <div className="col col-12 user-card mt-4">
              <h2>Стоимость услуг</h2>
              <div className="row justify-content-between services-container mt-4">
                <div className="col">
                  <p>Дизайн-проект интерьера дома</p>
                </div>
                <div className="col">
                  <p className="cost">от 900 ₽</p>
                </div>
              </div>
              <div className="row justify-content-between services-container mt-4">
                <div className="col">
                  <p>Авторский надзор в дизайне интерьеров</p>
                </div>
                <div className="col">
                  <p className="cost">от 900 ₽</p>
                </div>
              </div>
              <div className="row justify-content-between services-container mt-4">
                <div className="col">
                  <p>Трехмерная визуализация дизайна интерьера</p>
                </div>
                <div className="col">
                  <p className="cost">от 900 ₽</p>
                </div>
              </div>
            </div>
            <div className="col col-12 mt-5">
            <TabsHeader
              tabs={tabs}
              activeTab={activeTab}
              onTabChange={setActiveTab}
            />
            </div>
            <TabsBody activeTab={activeTab}>
              <div className="row">
                <div className="col col-12 mt-3">
                  <div className="row">
                    {(activeTab === 0 ? portfolios : articles).map((item) => (
                      <div key={item.id} className="col col-md-3 col-12 mt-2 img-margin">
                        <img className="rounded mx-auto d-block img-fluid" src={`/images/${item.image1}`} alt="" onClick={() => navigate(`/post/${item.id}`)} />
                        {item.text && <p className="like-post">{item.text}</p>}
                        <LikeButton initialLikes={item.likes} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col col-12 mt-3">
                  <div className="row">
                    {(activeTab === 0 ? portfolios : articles).map((item) => (
                      <div key={item.id} className="col col-md-3 col-12 mt-2 img-margin">
                        <img className="rounded mx-auto d-block img-fluid" src={`/images/${item.image1}`} alt="" onClick={() => navigate(`/post/${item.id}`)} />
                        {item.text && <p className="like-post">{item.text}</p>}
                        <LikeButton initialLikes={item.likes} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col col-12 reviews mt-4">
                  <div className="review-container">
                    <img className="circle review-avatar" src="/images/test-avatar.png" alt="" />
                    <div className="review-text">
                      <p>Виталий Долинский</p>
                      <div className="stars-date-container">
                        <Stars></Stars>
                        <div className="date-container">09.03.2024</div>
                      </div>
                    </div>
                  </div>
                  <p className="review-comment">
                    Кстати, акционеры крупнейших компаний призваны к ответу. Современные технологии достигли такого уровня.
                  </p>
                </div>
                <div className="col col-12 reviews mt-4">
                  <div className="review-container">
                    <img className="circle review-avatar" src="/images/test-avatar.png" alt="" />
                    <div className="review-text">
                      <p>Виталий Долинский</p>
                      <div className="stars-date-container">
                        <Stars></Stars>
                        <div className="date-container">09.03.2024</div>
                      </div>
                    </div>
                  </div>
                  <p className="review-comment">
                    Кстати, акционеры крупнейших компаний призваны к ответу. Современные технологии достигли такого уровня.
                  </p>
                </div>
                <div className="col col-12 reviews mt-4">
                  <div className="review-container">
                    <img className="circle review-avatar" src="/images/test-avatar.png" alt="" />
                    <div className="review-text">
                      <p>Виталий Долинский</p>
                      <div className="stars-date-container">
                        <Stars></Stars>
                        <div className="date-container">09.03.2024</div>
                      </div>
                    </div>
                  </div>
                  <p className="review-comment">
                    Кстати, акционеры крупнейших компаний призваны к ответу. Современные технологии достигли такого уровня.
                  </p>
                </div>
                <div className="col col-12 reviews mt-4">
                  <div className="review-container">
                    <img className="circle review-avatar" src="/images/test-avatar.png" alt="" />
                    <div className="review-text">
                      <p>Виталий Долинский</p>
                      <div className="stars-date-container">
                        <Stars></Stars>
                        <div className="date-container">09.03.2024</div>
                      </div>
                    </div>
                  </div>
                  <p className="review-comment">
                    Кстати, акционеры крупнейших компаний призваны к ответу. Современные технологии достигли такого уровня.
                  </p>
                </div>
              </div>
            </TabsBody>
            <div className="col col-12 mt-4">
              <h1 style={{textAlign: "center"}}>Какой заказ хотите предложить?</h1>
            </div>
            <div className="col col-12 mt-4 order-container-user">
              <h4>Проект жилого дома</h4>
              <p className="mt-2">Краснодар, мкр. Любимово 16 <br />Площадь 120 кв метр</p>
              <button className="btn btn-black mt-3 disabled"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M20.7096 5.79536C21.0987 6.18724 21.0965 6.82041 20.7046 7.20957L9.62772 18.2096C9.23776 18.5968 8.60839 18.5968 8.21844 18.2096L3.29536 13.3207C2.90348 12.9315 2.90127 12.2984 3.29043 11.9065C3.67959 11.5146 4.31276 11.5124 4.70464 11.9015L8.92308 16.0907L19.2954 5.79043C19.6872 5.40127 20.3204 5.40348 20.7096 5.79536Z" fill="#D2D2D5"/>
    </svg>
    Предложен</button>
            </div>
            <div className="col col-12 mt-4 order-container-user">
              <h4>Проект жилого дома</h4>
              <p className="mt-2">Краснодар, мкр. Любимово 16 <br />Площадь 120 кв метр</p>
              <button className="btn btn-black mt-3 disabled"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M20.7096 5.79536C21.0987 6.18724 21.0965 6.82041 20.7046 7.20957L9.62772 18.2096C9.23776 18.5968 8.60839 18.5968 8.21844 18.2096L3.29536 13.3207C2.90348 12.9315 2.90127 12.2984 3.29043 11.9065C3.67959 11.5146 4.31276 11.5124 4.70464 11.9015L8.92308 16.0907L19.2954 5.79043C19.6872 5.40127 20.3204 5.40348 20.7096 5.79536Z" fill="#D2D2D5"/>
    </svg>
    Предложен</button>
            </div>
            <div className="col col-12 mt-4 order-container-user">
              <h4>Проект жилого дома</h4>
              <p className="mt-2">Краснодар, мкр. Любимово 16 <br />Площадь 120 кв метр</p>
              <button className="btn btn-black mt-3">Предложить</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default DesignerProfile;